import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin';

export const TreasuryEntityList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <TextField source="country" />
      <TextField source="type" />
    </Datagrid>
  </List>
);

export const TreasuryEntityEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="uid" label="UID" />
      <TextInput source="name" />
      <TextInput source="country" />
      <TextInput source="type" />
    </SimpleForm>
  </Edit>
);

export const TreasuryEntityCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="uid" label="UID" required />
      <TextInput source="name" required />
      <TextInput source="country" />
      <TextInput source="type" />
    </SimpleForm>
  </Create>
);

export const TreasuryEntityShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <TextField source="country" />
      <TextField source="type" />
    </SimpleShowLayout>
  </Show>
);
